import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const PdfIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.34375 10.9375H3.0625V9.25H3.34375C3.80078 9.25 4.1875 9.63672 4.1875 10.0938C4.1875 10.5859 3.80078 10.9375 3.34375 10.9375ZM7 9.25H7.28125C7.5625 9.25 7.84375 9.53125 7.84375 9.8125V12.0625C7.84375 12.3789 7.5625 12.625 7.28125 12.625H7V9.25ZM8.125 0.25V4.75C8.125 5.38281 8.61719 5.875 9.25 5.875H13.75V16C13.75 17.2656 12.7305 18.25 11.5 18.25H2.5C1.23438 18.25 0.25 17.2656 0.25 16V2.5C0.25 1.26953 1.23438 0.25 2.5 0.25H8.125ZM2.5 8.125C2.18359 8.125 1.9375 8.40625 1.9375 8.6875V13.1875C1.9375 13.5039 2.18359 13.75 2.5 13.75C2.78125 13.75 3.0625 13.5039 3.0625 13.1875V12.0625H3.34375C4.39844 12.0625 5.3125 11.1836 5.3125 10.0938C5.3125 9.03906 4.39844 8.125 3.34375 8.125H2.5ZM5.875 13.1875C5.875 13.5039 6.12109 13.75 6.4375 13.75H7.28125C8.19531 13.75 8.96875 13.0117 8.96875 12.0625V9.8125C8.96875 8.89844 8.19531 8.125 7.28125 8.125H6.4375C6.12109 8.125 5.875 8.40625 5.875 8.6875V13.1875ZM10.375 8.125C10.0586 8.125 9.8125 8.40625 9.8125 8.6875V13.1875C9.8125 13.5039 10.0586 13.75 10.375 13.75C10.6562 13.75 10.9375 13.5039 10.9375 13.1875V11.5H12.0625C12.3438 11.5 12.625 11.2539 12.625 10.9375C12.625 10.6562 12.3438 10.375 12.0625 10.375H10.9375V9.25H12.0625C12.3438 9.25 12.625 9.00391 12.625 8.6875C12.625 8.40625 12.3438 8.125 12.0625 8.125H10.375ZM9.25 0.25L13.75 4.75H9.25V0.25Z"
        fill="#ED1717"
      />
    </SvgIcon>
  );
};

export default PdfIcon;
